import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { useEffect, useRef } from 'react';
import { createPortal } from 'react-dom';
const maxWidthClasses = {
    sm: 'max-w-sm',
    md: 'max-w-md',
    lg: 'max-w-xl',
};
export function Dialog({ isOpen, onClose, children, maxWidth = 'md' }) {
    const dialogRef = useRef(null);
    useEffect(() => {
        const handleKeyDown = (e) => {
            if (e.key === 'Escape' && isOpen)
                onClose();
        };
        document.addEventListener('keydown', handleKeyDown);
        return () => document.removeEventListener('keydown', handleKeyDown);
    }, [isOpen, onClose]);
    useEffect(() => {
        if (isOpen) {
            document.body.style.overflow = 'hidden';
            dialogRef.current?.focus();
        }
        else {
            document.body.style.overflow = '';
        }
        return () => { document.body.style.overflow = ''; };
    }, [isOpen]);
    if (!isOpen)
        return null;
    return createPortal(_jsxs("div", { className: "fixed inset-0 z-dialog-backdrop flex items-center justify-center p-4", "aria-labelledby": "dialog-title", role: "dialog", "aria-modal": "true", children: [_jsx("div", { className: "fixed inset-0 bg-overlay glass-backdrop-dim transition-opacity duration-150 ease-in-out", onClick: onClose }), _jsx("div", { ref: dialogRef, tabIndex: -1, className: `glass-panel-container glass-composited relative w-full max-h-[calc(100dvh-2rem)] flex flex-col rounded-lg glass-modal shadow-overlay ${maxWidthClasses[maxWidth]}`, children: _jsx("div", { className: "overflow-y-auto p-6 flex-1", children: children }) })] }), document.body);
}
//# sourceMappingURL=Dialog.js.map